import { apiEnv } from '@mgmresorts/wcl-utils';
import React from 'react';

var EscKeyListenContext = /*#__PURE__*/React.createContext({
  subscribe: function subscribe() {
    if (apiEnv === 'test') {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      return {
        unsubscribe: function unsubscribe() {}
      };
    }

    throw new TypeError("EscKeyListenContext isn't initialized");
  }
});

export { EscKeyListenContext };
